<template>
  <div class="nav-container">
    <div v-for="(linkset, index) in links" :key="index" class="linkcard">
      <router-link
        class="link"
        :class="current == link.val && 'actived'"
        v-for="link in linkset"
        :key="link.key"
        :to="`/elink?c=${link.val}`"
        >{{ link.key }}</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        [
          {
            key: "商業・職場",
            val: "商業・職場",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=528",
          },
          {
            key: "財經・投資",
            val: "財經・投資",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=516",
          },
          {
            key: "心靈・勵志",
            val: "心靈・勵志",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=521",
          },
          {
            key: "人性・心理",
            val: "人性・心理",
            link: "	http://site.magv.com/twcit/ListBook.aspx?mcaID=529",
          },
        ],
        [
          {
            key: "名家文學小說",
            val: "名家文學小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=524",
          },
          {
            key: "浪漫愛情小說",
            val: "浪漫愛情小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=525",
          },
          {
            key: "歷史武俠小說",
            val: "歷史武俠小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=526",
          },
          {
            val: "恐怖驚悚小說",
            key: "恐怖驚悚小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=527",
          },
        ],
        [
          {
            key: "保健・養生",
            val: "保健・養生",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=511",
          },
          {
            key: "人物・歷史",
            val: "人物・歷史",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=522",
          },
          {
            key: "命理・宗教",
            val: "命理・宗教",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=519",
          },
          {
            key: "語言・學習",
            val: "語言・學習",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=513",
          },
        ],
        [
          {
            key: "育兒・教養",
            val: "育兒・教養",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=518",
          },
          {
            key: "兩性・婚姻",
            val: "兩性・婚姻",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=206",
          },
          {
            key: "瘦身・美容",
            val: "瘦身・美容",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=515",
          },
          {
            key: "食譜・手作",
            val: "食譜・手作",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=404",
          },
        ],
        [
          {
            key: "福音・信仰",
            val: "福音・信仰",
            link: "	http://site.magv.com/twcit/ListBook.aspx?mcaID=530",
          },
          {
            key: "童書・繪本",
            val: "童書・繪本",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=510",
          },
          {
            key: "少女・漫畫",
            val: "漫畫",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=510",
          },
          {
            key: "其他・特刊",
            val: "其他・特刊",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=202",
          },
        ],
        [
          {
            key: "旅遊・飲食",
            val: "旅遊・飲食",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=520",
          },
          {
            key: "攝影・藝術",
            val: "攝影・藝術",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=517",
          },
          {
            key: "科普・生活",
            val: "科普・生活",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=512",
          },
          {
            key: "空間・建築",
            val: "空間・建築",
            link: "	http://site.magv.com/twcit/ListBook.aspx?mcaID=532",
          },
        ],
      ],
    };
  },
  computed: {
    current() {
      return this.$route.query.c;
    },
  },
};
</script>

<style scoped>
.nav-container {
  background-color: white;
  display: flex;
  flex-wrap: wrap;
}

.linkcard {
  margin: 0.1rem;
  /* min-width: 2.26rem; */
  border-bottom: 1px solid #474747;
}

.link {
  display: block;
  /* border-bottom: 1px solid #474747; */
  color: #474747;
  font-size: 0.18rem;
  line-height: 0.18rem;
  margin: 0.1rem 0;
  width: 1.2rem;
  padding: 5px;
  text-align: center;
}

.actived {
  background-color: rgb(239, 239, 239);
  border-radius: 5px;
}

.link:last-child {
  border-bottom: none;
}
</style>